import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NumericInputComponent } from '../../../form-components/numeric-input/numeric-input.component';

@Component({
  selector: 'app-table-header-number-input',
  templateUrl: '../../../../ui/form-components/numeric-input/numeric-input.component.html',
  styleUrls: ['./table-header-number-input.component.scss', '../table-column-inputs.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderNumberInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: []
})
export class TableHeaderNumberInputComponent extends NumericInputComponent {
  @Input() placeholder: string = $localize`Search`;
}
